import { CLIError, type Preset, type ProjectConfig } from "../types/types.js"

const presets: Record<string, Preset> = {
  "astro-blog": {
    config: {
      codeQuality: "biome",
      framework: "astro",
      gitHooks: false,
      metaFramework: "none",
      packageManager: "pnpm",
      tailwind: true,
      typescript: true,
    },
    description: "Astro with TypeScript and Tailwind CSS",
    name: "astro-blog",
  },
  "enterprise-next": {
    config: {
      codeQuality: "biome",
      framework: "react",
      gitHooks: true,
      metaFramework: "next",
      packageManager: "pnpm",
      tailwind: true,
      typescript: true,
    },
    description: "Next.js with all features enabled for enterprise projects",
    name: "enterprise-next",
  },
  "next-app": {
    config: {
      codeQuality: "biome",
      framework: "react",
      gitHooks: false,
      metaFramework: "next",
      packageManager: "pnpm",
      tailwind: true,
      typescript: true,
    },
    description: "Next.js with TypeScript, Tailwind CSS v4, and Biome",
    name: "next-app",
  },
  "react-vite": {
    config: {
      codeQuality: "biome",
      framework: "react",
      gitHooks: false,
      metaFramework: "none",
      packageManager: "pnpm",
      tailwind: false,
      typescript: true,
    },
    description: "React with Vite, TypeScript, and Biome",
    name: "react-vite",
  },
  "svelte-kit": {
    config: {
      codeQuality: "biome",
      framework: "svelte",
      gitHooks: true,
      metaFramework: "sveltekit",
      packageManager: "pnpm",
      tailwind: true,
      typescript: true,
    },
    description: "SvelteKit with TypeScript and Biome",
    name: "svelte-kit",
  },
  "vue-minimal": {
    config: {
      codeQuality: "eslint-prettier",
      framework: "vue",
      gitHooks: false,
      metaFramework: "none",
      packageManager: "npm",
      tailwind: false,
      typescript: false,
    },
    description: "Vue with JavaScript and ESLint + Prettier",
    name: "vue-minimal",
  },
}

export function loadPreset(presetName: string): Partial<ProjectConfig> {
  const preset = presets[presetName]

  if (!preset) {
    throw new CLIError(
      `Unknown preset: ${presetName}. Run 'create-frontend-app list-presets' to see available presets.`,
      "UNKNOWN_PRESET",
    )
  }

  return preset.config
}

export function listPresets(): Array<Preset> {
  return Object.values(presets)
}

export function getPreset(name: string): Preset | undefined {
  return presets[name]
}
